import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investmentcontract',
  templateUrl: './investmentcontract.component.html',
  styleUrls: ['./investmentcontract.component.css']
})
export class InvestmentcontractComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
